export enum Fees {
  App = 50,
  Credit = 2
}

export const FreeMB = 25;
